export class OperatorCapability {
  constructor(
    public hash?: string,
    public modelHash?: string,
    public modelName?: string,
    public modelReference?: number,
    public level?: string,
  ) { }

  clone() {
    return new OperatorCapability(
      this.hash,
      this.modelHash,
      this.modelName,
      this.modelReference,
      this.level,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operator-capability.ts